import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SubscriptionAssigned, SubscriptionPackages } from 'src/app/interfaces/installation';

@Component({
  selector: 'app-manager-packages-subscriptions',
  templateUrl: './manager-packages-subscriptions.page.html',
  styleUrls: ['./manager-packages-subscriptions.page.scss'],
})
export class ManagerPackagesSubscriptionsPage implements OnInit {
  subscriptions: SubscriptionAssigned[];
  items: any[] = [];
  flag = false;
  constructor(
    public modalCtrl: ModalController) { }


  ngOnInit() {
  //  // console.log(this.subscriptions);
    this.items = this.subscriptions;
  }

  activeItem(item) {
    this.flag = true;
  //  // console.log(item);
  }

  expandItem(item): void {
    if (this.flag) {
      this.flag = false;
      return;
    }
  //  // console.log(item);
    if (item.expanded) {
      item.expanded = false;
    } else {
      this.items.map(listItem => {
        if (item === listItem) {
          listItem.expanded = !listItem.expanded;
        } else {
          listItem.expanded = false;
        }
        return listItem;
      });
    }
  }

}
